import { render } from "./pageConfig.vue?vue&type=template&id=31657482"
import script from "./pageConfig.vue?vue&type=script&lang=js"
export * from "./pageConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/exHibitionPageConfig/pageConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31657482"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31657482', __exports__)) {
    console.log('reload')
    api.reload('31657482', __exports__)
  }
  
  module.hot.accept("./pageConfig.vue?vue&type=template&id=31657482", () => {
    console.log('re-render')
    api.rerender('31657482', render)
  })

}


export default __exports__